<template>
  <InputTable
    type="number"
    :value="valor"
    v-model.number="valor"
    :msgsError="[...msgArrayError, ...getShowErros()]"
    :loading="loading"
    :disabled="disabled || loading"
    :pulsarError="true"
    @change="onChange"
    @keypress="justNumbers"
    @keydown="stopArrowsAction"
    step="0.0001"
    :min="0"
  />
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import InputTable from '@/components/InputTable';

const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');

export default {
  name: 'InputLancarNotas',
  components: {
    InputTable
  },
  props: {
    showErros: Array,
    value: [String, Number],
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    numatalun: [String, Number],
    identificadordistribuirnotas: [String, Number],
    valornota: [String, Number],
    identificadordetalharatividade: [String, Number],
    disabled: {
      type: Boolean,
      default: false,
    },
    cdpessoal: [String, Number],
    cdmatric: [String, Number],
    cdtipesc: [String, Number],
    cdescola: [String, Number],
    valorDistribuicao: [String, Number],
    valorDetalhe: [String, Number],
    indicanaofez: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return  {
      valor: '',
      msgArrayError: [],
      loading: false,
    };
  },
  created(){
    this.addValue();
  },
  watch: {
    value(){
      this.addValue();
    },
    valor(){
      this.msgArrayError = [];
    }
  },
  methods: {
    getShowErros() {
      return (this.showErros) ? this.showErros : [];
    },
    addValue(){
      this.valor = this.value;
    },
    /* onInput(vl) {
      this.msgArrayError = [];
    }, */
    justNumbers(event){
      const currentCode = event.which || event.code;
      let currentKey = event.key;
      if (!currentKey) { currentKey = String.fromCharCode(currentCode); }
      if(!currentKey.match(/[0-9,.]/) || (this.valor !== null && this.valor.toString().length >= 6)) { event.preventDefault(); }
    },
    stopArrowsAction(event) {
      // debugger
      if(event.keyCode === 38 || event.keyCode === 40) { event.preventDefault(); }
    },
    async onChange() {
      this.msgArrayError = [];

      let valorMaximo = ((this.identificadordetalharatividade > 0)? this.valorDetalhe : this.valorDistribuicao) || 0;
      if(this.valor < 0) { return this.msgArrayError.push('Valor negativo não é permitido.'); }
      if((this.valor || 0) > valorMaximo) { return this.msgArrayError.push(`Valor máximo ${valorMaximo} pontos.`); }

      if(this.valor > 0) {
        // debugger
        const aux = this.valor.toString();
        const posicao = aux.indexOf('.');
        if(posicao > 0) { this.valor = parseFloat(aux.substring(0, posicao + 3)); }
      }

      const form = {
        aaletivo: this.ano,
        cdtipesc: this.cdtipesc,
        cdescola: this.cdescola,
        cdturma: this.cdturma,
        cddiscipl: this.disciplina,
        numatalun: this.numatalun, // falta passar
        cdpessoal: this.cdpessoal,
        cdmatric: this.cdmatric,
        identificadordistribuirnotas: this.identificadordistribuirnotas, // falta passar
        valor: this.valor,
        identificadordetalharatividade: this.identificadordetalharatividade, // falta passar
        indicanaofez: this.indicanaofez
      };

      this.loading = true;
      try {
        // const response = await DiarioEscolarRepository.setLancarNotas(form);
        // const response = await DiarioEscolarRepository.setLancarNotas(form);

        if(this.valor === '') { this.valor = null; }
        this.$emit('input', this.valor);

        this.$emit('addNota', form);
      }catch(error) {
        if (error.response && error.response.data.status == 'ERROR_BUSINESS_RULE') {
          this.msgArrayError = [error.response.data.errorMessage];
        } else {
          this.msgArrayError = ['Ocorreu um erro! Tente Novamente.'];
        }
      }
      finally {
        this.loading = false;
      }

    },
  },
}
</script>

<style lang="scss">

</style>
